import { Helmet } from 'react-helmet-async';

export default function SEOHead({
  title,
  description,
  image = '/assets/social-share.png',
  url,
  type = 'website',
  keywords = '',
  structuredData
}) {
  const fullTitle = title ? `${title} | Belu Tours` : 'Belu Tours | Viajes a tu medida';
  const fullUrl = url ? `https://belutoursviajesyturismo.tur.ar${url}` : 'https://belutoursviajesyturismo.tur.ar/';
  
  return (
    <Helmet>
      {/* Meta tags básicos */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`https://belutoursviajesyturismo.tur.ar${image}`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Belu Tours" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`https://belutoursviajesyturismo.tur.ar${image}`} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
